import { useEffect, useState, useRef } from 'react';
import CheckBox from '../../component/CheckBox';
import { ModalHeader } from '../../component/ModalRef';
import { useDispatch, useSelector } from 'react-redux';
import { NOTICE_CHECK_STATUS_CD } from '../../constant/Constant';
import { actionCheckNoticeSearch, actionCheckNoticeUpdate } from '../../module/modal/EnrolmentCautionModule';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import NullCheckUtil from '../../util/NullCheckUtil';
import PopupRef from '../../component/PopupRef';

const EnrolmentCautionModal = ({ userId, isEnrolment = false, modalRef }) => {
    const dispatch = useDispatch();
    const { semesterUser } = useSelector((state) => state.enrolmentCautionState);
    const [checked, setChecked] = useState(false);

    const popupRef = useRef(null);

    useEffect(() => {
        if (isEnrolment) {
            dispatch(actionCheckNoticeSearch({ params: { userId } }));
        }
    }, []);

    useEffect(() => {
        if (isEnrolment) {
            if (NullCheckUtil.isNotNull(semesterUser)) {
                if (NOTICE_CHECK_STATUS_CD.CONFIRM == semesterUser.noticeCheckStatusCd) {
                    setChecked(true);
                } else {
                    setChecked(false);
                }
            } else {
                setChecked(false);
            }
        }
    }, [semesterUser]);

    const handleCancel = (e) => {
        modalRef.current.close();
    };

    const handleConfirm = (e) => {
        if (isEnrolment) {
            if (checked) {
                dispatch(
                    actionCheckNoticeUpdate({
                        params: { userId },
                        callback: () => {
                            popupRef.current.openAlert('수강신청 유의사항 동의여부가 처리되었습니다.', () => {
                                return function () {
                                    modalRef.current.close();
                                };
                            });
                        },
                    }),
                );
            } else {
                popupRef.current.openWarning('수강신청 유의사항에 동의하지 않으면 수강신청이 불가합니다.');
            }
        } else {
            modalRef.current.close();
        }
    };

    return (
        <>
            <ModalHeader title='수강신청 유의사항' modalRef={modalRef} />
            <div className='modal-body'>
                <div>
                    <div className='notice-popup-inner'>
                        <p className='info-icon-txt'>아래의 안내 사항을 꼭 확인해주세요.</p>
                        <ul className='explain-txt'>
                            <li>
                                혁신융합대학사업(미래자동차) 수강신청은 본인의 수강신청 -{'>'} 본교 승인 및 교환학생
                                추천 -{'>'} 교류대학의 수강등록 과정으로 진행됩니다.
                            </li>
                            <li>
                                수강 학기 현재 <strong>재학 중인자(휴학생 불가)</strong>만 가능합니다.
                            </li>
                            <li>
                                본교의 자격조건을 만족(예:직전학기 취득학점 평점평균 2.5이상 등)하는 경우에만 본교승인이
                                이루어 집니다.
                            </li>
                            <li>
                                대학간 학점교류를 위한 수강신청으로 본교 과목은 수강 신청이 불가능합니다. (본교 수강신청
                                일정에 따라 본교 수강신청시스템에서 수강신청)
                            </li>
                            <li>
                                개인별 수강 신청 가능학점 범위내에서 <strong>최대 9학점</strong>까지 신청이 가능합니다.
                            </li>
                            <li>
                                수강 가능 학점을 초과하여 신청한 경우 초과된 교류대학의 성적은 일체 인정하지 않습니다.
                            </li>
                            <li>
                                <strong>
                                    본교 및 교류대학(수강정원 등)의 사정에 따라 수강 등록이 제한(거절)될 수 있습니다.
                                </strong>
                            </li>
                            <li>
                                교류대학의 취득한 성적은 해당 대학의 성적이 확정된 후 학점 인정 절차가 진행되므로 성적이
                                늦게 입력될 수 있습니다.
                            </li>
                            <li>
                                <strong>
                                    혁신융합대학사업(미래자동차) 수강신청 강의시간이 본교 수강신청 강의시간과 중복되지
                                    않는지 확인하시기 바랍니다.
                                </strong>
                            </li>
                            <li>상기 사항 이외의 본교 및 교류대학이 따로 정한 사항이 있는 경우 그에 따릅니다.</li>
                        </ul>
                        {isEnrolment ? (
                            <div className='notice-check'>
                                <CheckBox
                                    checked={checked}
                                    onChecked={setChecked}
                                    span='안내사항을 확인하였으며, 이에 동의합니다.'
                                />
                            </div>
                        ) : (
                            <></>
                        )}
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    {isEnrolment ? <CancelButtonBox title='취소' onClick={(e) => handleCancel()} /> : <></>}
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </>
    );
};

export default EnrolmentCautionModal;
